import { Base } from 'layouts'
import { ManageClientGroup as ToManage } from 'components'

import * as S from './styled'

export function ManageClientGroup() {
  return (
    <Base>
      <S.GridContainer container>
        <ToManage />
      </S.GridContainer>
    </Base>
  )
}
